/*
 * Beebizco – spend-tier progress bar.
 * Reads the cart subtotal and shows how far the shopper is from the next discount tier.
 * Phases (dates, tiers, notes) are passed in as JSON from snippets/bbz-tier-progress.liquid,
 * so the bar only ever promises the discount that is actually running at that moment.
 */
(function (root) {
  function activePhase(phases, now) {
    for (var i = 0; i < phases.length; i++) {
      var phase = phases[i];
      var start = phase.start ? Date.parse(phase.start) : -Infinity;
      var end = phase.end ? Date.parse(phase.end) : Infinity;
      if (now >= start && now < end) return phase;
    }
    return null;
  }

  // subtotal and tier minimums are in pence.
  function tierState(subtotal, phase) {
    if (!phase || !phase.tiers || !phase.tiers.length) return null;
    var tiers = phase.tiers.slice().sort(function (a, b) { return a.min - b.min; });
    var top = tiers[tiers.length - 1];
    var unlocked = null;
    var next = null;
    for (var i = 0; i < tiers.length; i++) {
      if (subtotal >= tiers[i].min) unlocked = tiers[i];
      else if (!next) next = tiers[i];
    }
    return {
      unlocked: unlocked,
      next: next,
      remaining: next ? next.min - subtotal : 0,
      progress: Math.max(0, Math.min(1, subtotal / top.min)),
      markers: tiers.map(function (t) { return { pct: t.pct, at: t.min / top.min, reached: subtotal >= t.min }; }),
      note: phase.note || ''
    };
  }

  function formatMoney(pence) {
    var pounds = pence / 100;
    return '£' + (pence % 100 === 0 ? pounds.toFixed(0) : pounds.toFixed(2));
  }

  function message(state) {
    if (!state) return '';
    if (!state.unlocked) {
      return 'Spend <strong>' + formatMoney(state.remaining) + '</strong> more to get <strong>' + state.next.pct + '% off</strong>';
    }
    if (state.next) {
      return 'You’ve unlocked <strong>' + state.unlocked.pct + '% off</strong>. Spend <strong>' +
        formatMoney(state.remaining) + '</strong> more for <strong>' + state.next.pct + '% off</strong>';
    }
    return state.markers.length > 1
      ? 'You’ve unlocked our top saving: <strong>' + state.unlocked.pct + '% off</strong>'
      : 'You’ve unlocked <strong>' + state.unlocked.pct + '% off</strong> your order';
  }

  var api = { activePhase: activePhase, tierState: tierState, formatMoney: formatMoney, message: message };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
    return;
  }
  root.BbzTiers = api;

  if (!root.customElements || root.customElements.get('bbz-tier-progress')) return;

  root.customElements.define(
    'bbz-tier-progress',
    class BbzTierProgress extends HTMLElement {
      connectedCallback() {
        try {
          this.phases = JSON.parse(this.querySelector('[data-phases]').textContent);
        } catch (error) {
          this.phases = [];
        }
        this.text = this.querySelector('[data-text]');
        this.note = this.querySelector('[data-note]');
        this.fill = this.querySelector('[data-fill]');
        this.track = this.querySelector('[data-track]');
        this.render(parseInt(this.dataset.subtotal, 10) || 0);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
        }
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      refresh() {
        fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', {
          headers: { Accept: 'application/json' }
        })
          .then((response) => response.json())
          .then((cart) => this.render(cart.items_subtotal_price))
          .catch(() => {});
      }

      render(subtotal) {
        const state = tierState(subtotal, activePhase(this.phases, Date.now()));
        if (!state || subtotal <= 0) {
          this.hidden = true;
          return;
        }
        this.hidden = false;
        this.classList.toggle('is-complete', !state.next);
        this.text.innerHTML = message(state);
        this.fill.style.transform = 'scaleX(' + state.progress + ')';
        this.track.setAttribute('aria-valuenow', Math.round(state.progress * 100));

        this.querySelectorAll('[data-marker]').forEach((el) => el.remove());
        if (state.markers.length > 1) {
          state.markers.forEach((marker) => {
            const el = document.createElement('span');
            el.className = 'bbz-tiers__marker' + (marker.reached ? ' is-reached' : '');
            el.dataset.marker = '';
            el.style.left = marker.at * 100 + '%';
            el.textContent = marker.pct + '%';
            this.track.appendChild(el);
          });
        }

        if (this.note) {
          this.note.textContent = state.note;
          this.note.hidden = !state.note;
        }
      }
    }
  );
})(typeof window !== 'undefined' ? window : globalThis);
